import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types/i18n'

export default {
  flashSalesTag: {
    id: 'product_page_flash_sales_tag',
    defaultMessage: 'Flash Deal',
  },
  sellerFlashSalesTag: {
    id: 'product_page_seller_flash_sales_tag',
    defaultMessage: 'Price drop',
  },
} as Record<string, I18nDefinition>
